import {
    Chart as ChartJS,
    BarController,
    LineController,
    DoughnutController,
    BarElement,
    LineElement,
    ArcElement,
    PointElement,
    CategoryScale,
    LinearScale,
    Tooltip,
} from 'chart.js';

ChartJS.register(BarController, LineController, DoughnutController, BarElement, LineElement, ArcElement, PointElement, CategoryScale, LinearScale, Tooltip);

const LATO = "'Lato', sans-serif";

export const TICK_FONT = { size: 11, family: LATO };

// show_value_labels gets crowded/unreadable past this many x-axis categories - charts drop the numbers and keep just the bars/line
export const MAX_VALUE_LABEL_CATEGORIES = 10;

export function hexToRgba(hex, alpha) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r},${g},${b},${alpha})`;
}

export function drawRoundedRect(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r,     y - h / 2);
    ctx.lineTo(x + w - r, y - h / 2);
    ctx.quadraticCurveTo(x + w, y - h / 2, x + w, y - h / 2 + r);
    ctx.lineTo(x + w,     y + h / 2 - r);
    ctx.quadraticCurveTo(x + w, y + h / 2, x + w - r, y + h / 2);
    ctx.lineTo(x + r,     y + h / 2);
    ctx.quadraticCurveTo(x,     y + h / 2, x,     y + h / 2 - r);
    ctx.lineTo(x,         y - h / 2 + r);
    ctx.quadraticCurveTo(x,     y - h / 2, x + r, y - h / 2);
    ctx.closePath();
}

export function ceilNice(rough) {
    if (rough <= 0) return 1;
    const mag = Math.pow(10, Math.floor(Math.log10(rough)));
    const n   = rough / mag;
    return (n <= 1 ? 1 : n <= 2 ? 2 : n <= 2.5 ? 2.5 : n <= 5 ? 5 : 10) * mag;
}

// a "nice" step for ~targetIntervals ticks, extended only as many steps as needed to cover maxValue
export function niceAxisScale(maxValue, targetIntervals) {
    const step = ceilNice(maxValue / targetIntervals);
    const intervals = Math.max(1, Math.ceil(maxValue / step));
    return { step, intervals, max: step * intervals };
}

// afterBuildTicks helper: a tick every `step`, `intervals + 1` of them, starting at 0.
export function niceAxisTicks(step, intervals) {
    return Array.from({ length: intervals + 1 }, (_, i) => ({ value: i * step }));
}

// same K/M/B breakpoints as amountFormatter, minus the forced ".00" on whole numbers.
export function formatAxisAmount(value) {
    const withUnit = (num, suffix) => {
        const rounded = Math.round(num * 100) / 100;
        return `$${Number.isInteger(rounded) ? rounded : rounded.toFixed(2)}${suffix}`;
    };
    if (value >= 1000000000) return withUnit(value / 1000000000, 'B');
    if (value >= 1000000) return withUnit(value / 1000000, 'M');
    if (value >= 1000) return withUnit(value / 1000, 'K');
    return `$${Math.round(value)}`;
}
